import * as types from "../Action/type"
const initialState = {
    toogleStatus: true,
}


const SideMenuReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SIDEMENUSTATUS:
      return { ...state, toogleStatus:action.payload }
    default:
      return state;
  }


}
export default SideMenuReducer;
